<template>
  <div class="profile-badge d-flex">
    <div class="d-flex flex-column justify-content-center text-left">
      <div class="text-uppercase">
        <strong>{{ this.user.username }}</strong>
      </div>
      <div class="small" v-if="user.department">{{ user.department }}</div>
      <div class="small mt-1" v-if="user.email">{{ user.email }}</div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState(["user"]),
    fullName() {
      if (this.user.firstName || this.user.lastName) {
        return `${this.user.firstName} ${this.user.lastName}`.trim();
      }

      return null;
    },
    avatarText() {
      return getInitials(this.user.username);
    },
    avatarImage() {
      if (this.user.image) {
        return "data:image/png;base64," + this.user.image;
      } else {
        return "";
      }
    }
  }
};
</script>
